// Local replacement for @codemaniack/preloader-ui ElipsisLoader
import React from 'react';
import './ElipsisLoader.less';

const ElipsisLoader = ({ size = 'medium', color = '#000' }) => {
  return (
    <div className={`ellipsis-loader ellipsis-loader--${size}`}>
      <div style={{ backgroundColor: color }}></div>
      <div style={{ backgroundColor: color }}></div>
      <div style={{ backgroundColor: color }}></div>
    </div>
  );
};

export default ElipsisLoader;
